// T270(6)/T161 — the three table cells, shared by AvailableRow and the two
// on-demand panels. Presentational and prop-only; they referenced nothing in
// DashboardPage's scope, which is why they could sit inline unnoticed.
// T044 — Empty state with clear action prompt. Slightly bolder than the
// previous bare paragraph so first-time operators have somewhere to look.
export function Th({ children, className = '' }) {
  return <th className={`px-3 py-2 text-left font-medium ${className}`}>{children}</th>;
}

export function Td({ children, className = '' }) {
  return <td className={`px-3 py-2.5 ${className}`}>{children}</td>;
}

export default function LocationCell({ location }) {
  if (!location) return <span className="text-slate-500">—</span>;
  const parts = [location.city, location.country].filter(Boolean);
  const remote = location.remote && location.remote !== 'unknown' ? location.remote : null;
  return (
    <div className="text-slate-300">
      {parts.length > 0 ? parts.join(', ') : <span className="text-slate-500">—</span>}
      {remote && (
        <span className="ml-1 text-xs text-slate-500">· {remote}</span>
      )}
    </div>
  );
}
